module.exports = __webpack_public_path__ + "static/media/home-page-hero-banner.7daa0af5.png";